// Module
var code = "<react-component name=\"KioskAlertsReport\"></react-component>\n";
// Exports
module.exports = code;